import React, { memo } from 'react';

import * as Types from './types';

import style from './AccordionCellNew.scss';

export const AccordionCellNew: React.FC<Types.IAccordionCellProps> = memo(({ className = '', content }) => (
    <div className={`${className} ${style.cell}`}>{content}</div>
));
